import { BaseComponentProps } from 'src/modules/shared/types/component.type';

interface SeparatorProps extends BaseComponentProps {
  padded?: boolean;
  orientation?: 'horizontal' | 'vertical';
}

export const Separator: React.FC<SeparatorProps> = ({
  className = '',
  padded = false,
  orientation = 'horizontal',
}) => {
  const orientationClasses =
    orientation === 'horizontal' ? 'h-px w-full' : 'h-full min-h-[20px] w-px';

  const paddingClasses = padded
    ? orientation === 'horizontal'
      ? 'px-4'
      : 'py-4'
    : '';

  return (
    <div
      className={`${orientation === 'vertical' ? 'h-full' : ''} ${paddingClasses}`}
    >
      <div className={`bg-secondary-200 ${orientationClasses} ${className}`} />
    </div>
  );
};
